exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Divider{background:var(--divider)}.Divider.row{width:1px;height:20px;margin:4px 0;align-self:center}.Divider.column{width:auto;height:1px;margin:0 4px}", ""]);

// exports
